module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers/client.js
// module id = 867
// module chunks = 13